var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-container"},[_c('div',{staticClass:"text-style"},[(_vm.isShowLabel())?_c('span',{staticClass:"text-styling-one"},[_vm._v(_vm._s(_vm.$t(_vm.label)))]):_vm._e(),_c('span',{class:_vm.getTextClass()},[_vm._v(" "+_vm._s(_vm.localValue)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }